import { Clock, X } from "lucide-react";

interface TimeFilterProps {
  value: "today" | "week" | "month" | null;
  onClear: () => void;
}

const TimeFilter = ({ value, onClear }: TimeFilterProps) => {
  if (!value) return null;

  const getLabel = () => {
    switch (value) {
      case "today":
        return "Today";
      case "week":
        return "Past week";
      case "month":
        return "Past month";
      default:
        return value;
    }
  };

  return (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-muted text-foreground border border-border hover:bg-accent rounded-lg text-xs font-medium transition-colors">
      <Clock className="w-3.5 h-3.5 text-muted-foreground" />
      <span>{getLabel()}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClear();
        }}
        className="ml-1 -mr-1 p-0.5 rounded-md hover:bg-accent transition-colors"
        aria-label="Clear time filter"
      >
        <X className="w-3.5 h-3.5 text-muted-foreground" />
      </button>
    </div>
  );
};

export default TimeFilter;
